// Per-user operational area access (deny-by-default). Admins always have every area.
export const AREA_KEYS = ["scouting", "medical", "director", "analysis"];

export const AREA_LABEL = {
  scouting: "Scouting",
  medical: "Medical Health",
  director: "Sport Director",
  analysis: "Analysis",
};

export function canAccessArea(user, area) {
  if (!user || typeof user !== "object") return false;
  if (user.is_admin) return true;
  return (user.allowed_areas || []).includes(area);
}
